/*
 * 左侧菜单栏上的Logo
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-31 20:30:42
 * @Last Modified by: zhiwei.luo@zuolin.com
 * @Last Modified time: 2020-09-15 12:11:34
 */

import * as React from 'react';
import PropTypes from 'prop-types';
import './index.less';

const prefixCls = 'eh-header-logo-component';

export default class HeaderLogo extends React.PureComponent {
	render () {
		const { url, style, isOpen } = this.props;

		return (
			<div className={prefixCls} style={style}>
				<img className ={ isOpen ? `${prefixCls}-expand` : `${prefixCls}-folding`} src={url} />
			</div>
		);
	}
}

HeaderLogo.propTypes = {
	// 样式
	url: PropTypes.string,
	// 样式
	style: PropTypes.object
};
